import { GroupId } from '../typings/groups';
import { RetargetingConditionData } from '../typings/retargeting';

export const OPEN_RETARGETING_EDITOR = 'OPEN_RETARGETING_EDITOR';
export type OPEN_RETARGETING_EDITOR = typeof OPEN_RETARGETING_EDITOR;

export interface OpenRetargetingEditor {
    type: OPEN_RETARGETING_EDITOR;
    id: string;
    conditionsData: Array<RetargetingConditionData>;
    selectedConditionsIds: Array<string>;
}

export function openRetargetingEditor(
    id: string,
    conditionsData: Array<RetargetingConditionData>,
    selectedConditionsIds: Array<string>
): OpenRetargetingEditor {
    return {
        type: OPEN_RETARGETING_EDITOR,
        id,
        conditionsData,
        selectedConditionsIds
    };
}

export const CLOSE_RETARGETING_EDITOR = 'CLOSE_RETARGETING_EDITOR';
export type CLOSE_RETARGETING_EDITOR = typeof CLOSE_RETARGETING_EDITOR;

export interface CloseRetargetingEditor {
    type: CLOSE_RETARGETING_EDITOR;
    id: string;
}

export function closeRetargetingEditor(id: string): CloseRetargetingEditor {
    return {
        type: CLOSE_RETARGETING_EDITOR,
        id
    };
}

export const CHANGE_RETARGETING_LIST_ITEM_SELECTION = 'CHANGE_RETARGETING_LIST_ITEM_SELECTION';
export type CHANGE_RETARGETING_LIST_ITEM_SELECTION = typeof CHANGE_RETARGETING_LIST_ITEM_SELECTION;

export interface ChangeRetargetingListItemSelection {
    type: CHANGE_RETARGETING_LIST_ITEM_SELECTION;
    id: string;
    index: number;
}

export function changeRetargetingListItemSelection(id: string, index: number): ChangeRetargetingListItemSelection {
    return {
        type: CHANGE_RETARGETING_LIST_ITEM_SELECTION,
        id,
        index
    };
}

export const CHANGE_RETARGETING_LIST_SELECTION = 'CHANGE_RETARGETING_LIST_SELECTION';
export type CHANGE_RETARGETING_LIST_SELECTION = typeof CHANGE_RETARGETING_LIST_SELECTION;

export interface ChangeRetargetingListSelection {
    type: CHANGE_RETARGETING_LIST_SELECTION;
    id: string;
    isSelected: boolean;
}

export function changeRetargetingListSelection(id: string, isSelected: boolean): ChangeRetargetingListSelection {
    return {
        type: CHANGE_RETARGETING_LIST_SELECTION,
        id,
        isSelected
    };
}

export const REQUEST_DELETE_RETARGETING_LIST_ITEM = 'REQUEST_DELETE_RETARGETING_LIST_ITEM';
export type REQUEST_DELETE_RETARGETING_LIST_ITEM = typeof REQUEST_DELETE_RETARGETING_LIST_ITEM;

export interface RequestDeleteRetargetingListItem {
    type: REQUEST_DELETE_RETARGETING_LIST_ITEM;
    id: string;
    index: number;
}

export function requestDeleteRetargetingListItem(id: string, index: number): RequestDeleteRetargetingListItem {
    return {
        type: REQUEST_DELETE_RETARGETING_LIST_ITEM,
        id,
        index
    };
}

export const DELETE_RETARGETING_LIST_ITEM = 'DELETE_RETARGETING_LIST_ITEM';
export type DELETE_RETARGETING_LIST_ITEM = typeof DELETE_RETARGETING_LIST_ITEM;

export interface DeleteRetargetingListItem {
    type: DELETE_RETARGETING_LIST_ITEM;
    id: string;
    index: number;
}

export function deleteRetargetingListItem(id: string, index: number): DeleteRetargetingListItem {
    return {
        type: DELETE_RETARGETING_LIST_ITEM,
        id,
        index
    };
}

export const EDIT_RETARGETING_LIST_ITEM = 'EDIT_RETARGETING_LIST_ITEM';
export type EDIT_RETARGETING_LIST_ITEM = typeof EDIT_RETARGETING_LIST_ITEM;

export interface EditRetargetingListItem {
    type: EDIT_RETARGETING_LIST_ITEM;
    id: string;
    index: number;
}

export function editRetargetingListItem(id: string, index: number): EditRetargetingListItem {
    return {
        type: EDIT_RETARGETING_LIST_ITEM,
        id,
        index
    };
}

export const UPDATE_RETARGETING_LIST_ITEM = 'UPDATE_RETARGETING_LIST_ITEM';
export type UPDATE_RETARGETING_LIST_ITEM = typeof UPDATE_RETARGETING_LIST_ITEM;

export interface UpdateRetargetingListItem {
    type: UPDATE_RETARGETING_LIST_ITEM;
    conditionData: RetargetingConditionData;
}

export function updateRetargetingListItem(conditionData: RetargetingConditionData): UpdateRetargetingListItem {
    return {
        type: UPDATE_RETARGETING_LIST_ITEM,
        conditionData
    };
}

export const ADD_RETARGETING_LIST_ITEM = 'ADD_RETARGETING_LIST_ITEM';
export type ADD_RETARGETING_LIST_ITEM = typeof ADD_RETARGETING_LIST_ITEM;

export interface AddRetargetingListItem {
    type: ADD_RETARGETING_LIST_ITEM;
    groupId: GroupId;
    conditionData: RetargetingConditionData;
}

export function addRetargetingListItem(
    groupId: GroupId,
    conditionData: RetargetingConditionData
): AddRetargetingListItem {
    return {
        type: ADD_RETARGETING_LIST_ITEM,
        groupId,
        conditionData
    };
}

export const CANCEL_DELETE_RETARGETING_LIST_ITEM = 'CANCEL_DELETE_RETARGETING_LIST_ITEM';
export type CANCEL_DELETE_RETARGETING_LIST_ITEM = typeof CANCEL_DELETE_RETARGETING_LIST_ITEM;

export interface CancelDeleteRetargetingListItem {
    type: CANCEL_DELETE_RETARGETING_LIST_ITEM;
    id: string;
    index: number;
}

export function cancelDeleteRetargetingListItem(id: string, index: number): CancelDeleteRetargetingListItem {
    return {
        type: CANCEL_DELETE_RETARGETING_LIST_ITEM,
        id,
        index
    };
}

export const RESET_RETARGETING_EDITORS = 'RESET_RETARGETING_EDITORS';
export type RESET_RETARGETING_EDITORS = typeof RESET_RETARGETING_EDITORS;

export interface ResetRetargetingEditors {
    type: RESET_RETARGETING_EDITORS;
}

export function resetRetargetingEditors(): ResetRetargetingEditors {
    return {
        type: RESET_RETARGETING_EDITORS
    };
}

export type RetargetingEditorAction =
    | OpenRetargetingEditor
    | CloseRetargetingEditor
    | ChangeRetargetingListItemSelection
    | ChangeRetargetingListSelection
    | RequestDeleteRetargetingListItem
    | DeleteRetargetingListItem
    | EditRetargetingListItem
    | UpdateRetargetingListItem
    | AddRetargetingListItem
    | CancelDeleteRetargetingListItem
    | ResetRetargetingEditors;
